<div class="container">
  <input
    matInput
    (dateInput)="dateChangedByUser($event)"
    [matDatepicker]="dp"
    [formControl]="dateFormControl()"
    class="dateField"
    (click)="dp.open()"
    [readonly]="true"
  />
  <mat-datepicker #dp disabled="false"></mat-datepicker>
  @if (!hideRelativeWeeksAndDays()) {
    (
    <input
      class="relativeFields"
      type="text"
      [value]="relativeWeeksDisplay()"
      (blur)="relativeWeeksBlurred($any($event.target).value)"
      [disabled]="disabled()"
    />
    @if (!hideRelativeDays()) {
      w
      <input
        class="relativeFields"
        type="text"
        [value]="relativeDays()"
        (blur)="relativeDaysBlurred($any($event.target).value)"
        [disabled]="disabled()"
      />d)
    } @else {
      w)
    }
  }
</div>
